<template>
  <div class="main">
    <el-dialog
      title="评价"
      :visible.sync="dialogVisible"
      width="600px"
      :before-close="handleClose">
      <div>
        <div class="margin-bottom flex justify-start align-center">
          <div class="label margin-right-xs">评分：</div>
          <el-rate
            v-model="score"
            :disabled="pjId ? false :true"
            :texts="['1分','2分','3分','4分','5分']"
            show-text>
          </el-rate>
        </div>
        <div class=" flex justify-start">
          <div class="label margin-right-xs">评价：</div>
          <el-input type="textarea" :rows="4"  v-model="evaluate" :disabled="pjId ? false :true" resize="none" placeholder="可以从专业能力、工作态度等方面评价" class="flex-sub"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" >
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" v-if="pjId" @click="sub">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
import {
 evaluateInternalYuyue
} from "@/api/index";
import {urlStr} from "@/config";
export default {
  name: "reservation",
  props: {
    pjId: {
      type: [String,Number],
      default: ''
    },
    dialogVisible:{
      type: Boolean,
      default: false
    },
    item:{
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      urlStr: urlStr,
      score: 0,
      evaluate:'',
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  components: {},
  created() {

  },
  methods: {
    handleClose(data = false){
      this.score =  0
      this.evaluate = ''
      this.$emit('handleClose',data)
    },
    tabChange(){
      this.page = 1
      this.List()
    },

    // 评价提交
    async sub(){
      if(!this.score) return this.$message.error('请选择评分')
      if(!this.evaluate) return this.$message.error('请填写评价')
      let _data = await evaluateInternalYuyue(this.user.mid,this.pjId,this.score,this.evaluate);
      if(_data.status === 200){
        this.handleClose(true)
        this.$message.success('评价成功')
      }else {
        this.$message.error(_data.msg)
      }
    },


  },
  watch: {
    dialogVisible(){
      if(this.dialogVisible && !this.pjId) {
        this.score = this.item.score
        this.evaluate = this.item.evaluate
      }
    }
  },
  filters: {

  }
}
</script>

<style scoped lang="scss">
.main {
  display: flex;
  flex-direction: column;
}
</style>


